import { useMemo } from "react";
import useAuthentication from "hooks/useAuthentication.hook";
import { useChatConversations } from "hooks/chat/useChatConversations.hook";
import * as conversationsSync from "services/sync/resources/chat/conversations.sync";

export function useChatAgentConversations({ enabled = true, lineId } = {}) {
  const { user } = useAuthentication();

  const userId = useMemo(() => {
    return user.uid;
  }, [user.uid]);

  return useChatConversations({
    enabled,
    lineId,
    userId,
    syncFn: conversationsSync.agent,
  });
}